import { createAction, createAsyncAction } from 'typesafe-actions';
import {
  EmployeeFormType,
  EmployeeInfo,
  EmployeeModalType,
  GetEmployeesParams,
  GetVacantEmployeesParams,
} from './types';

export const getEmployeesAsync = createAsyncAction(
  'employees/GET_EMPLOYEES_REQUEST',
  'employees/GET_EMPLOYEES_SUCCESS',
  'employees/GET_EMPLOYEES_FAILURE',
)<GetEmployeesParams, { total: number; data: any[] }, Error>();

export const getVacantEmployeesAsync = createAsyncAction(
  'employees/GET_VACANT_EMPLOYEES_REQUEST',
  'employees/GET_VACANT_EMPLOYEES_SUCCESS',
  'employees/GET_VACANT_EMPLOYEES_FAILURE',
)<GetVacantEmployeesParams, { total: number; employees: any[] }, Error>();

export const updateEmployeeAsync = createAsyncAction(
  'employees/UPDATE_EMPLOYEE_REQUEST',
  'employees/UPDATE_EMPLOYEE_SUCCESS',
  'employees/UPDATE_EMPLOYEE_FAILURE',
)<EmployeeFormType, {}, string>();

export const addEmployeeAsync = createAsyncAction(
  'employees/ADD_EMPLOYEE_REQUEST',
  'employees/ADD_EMPLOYEE_SUCCESS',
  'employees/ADD_EMPLOYEE_FAILURE',
)<EmployeeFormType, {}, Error>();

export const exportCSVEmployeesAsync = createAsyncAction(
  'employees/EXPORT_CSV_EMPLOYEES_REQUEST',
  'employees/EXPORT_CSV_EMPLOYEES_SUCCESS',
  'employees/EXPORT_CSV_EMPLOYEES_FAILURE',
)<void, void, Error>();

export const setEmployees = createAction('employees/SET_EMPLOYEES')<Array<EmployeeInfo>>();
export const setSelectedEmployee = createAction('employees/SET_SELECTED_EMPLOYEE')<EmployeeInfo>();
export const setOpenEmployeeModal = createAction('employees/SET_OPEN_EMPLOYEE_MODAL')<EmployeeModalType>();
